export default __webpack_public_path__ + "static/media/fav-icon.cd4252d0.svg";